import { render } from "./product-gallery.vue?vue&type=template&id=7c0199bc"
import script from "./product-gallery.vue?vue&type=script&lang=js"
export * from "./product-gallery.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-golive-uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__